import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import HoneycombLogo from './HoneycombLogo';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <HoneycombLogo size={36} />
                            <span className="logo-text">SkillHive</span>
                        </div>
                        <p className="footer-description">
                            Your trusted platform for connecting with verified professionals for all home services.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Services</h4>
                        <ul>
                            <li><Link to="/service/electrician">Electrician</Link></li>
                            <li><Link to="/service/plumber">Plumber</Link></li>
                            <li><Link to="/service/carpenter">Carpenter</Link></li>
                            <li><Link to="/service/ac-repair">AC Repair</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Company</h4>
                        <ul>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/">How It Works</Link></li>

                            <li><Link to="/">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Support</h4>
                        <ul>
                            <li><Link to="/">Help Center</Link></li>
                            <li><Link to="/">Safety</Link></li>
                            <li><Link to="/">Privacy Policy</Link></li>
                            <li><Link to="/">Terms of Service</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2024 SkillHive. All rights reserved.</p>
                    <div className="social-links">
                        <a href="#facebook" aria-label="Facebook"><FaFacebook /></a>
                        <a href="#twitter" aria-label="Twitter"><FaTwitter /></a>
                        <a href="#instagram" aria-label="Instagram"><FaInstagram /></a>
                        <a href="#linkedin" aria-label="LinkedIn"><FaLinkedin /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
